export const songsSnippets = [
  "And brought it back to the nest, singing microphone check. One two one two, this is just a test!",
  "That's me on the back of the bus. That's me in the cell. That's me inside your head.",
  "I said I bet that you look good on the dance floor. Dancing to electro-pop like a robot from 1984.",
  "A modern day warrior. Mean, mean stride. Today's Tom Sawyer. Mean, mean pride.",
  "All I ever wanted. All I ever needed is here in my arms. Words are very unnecessary. They can only do harm.",
  "And I'm watchin' and I'm waitin' Hopin' for the best, Even think I'll go to prayin' Every time I hear 'em sayin' That there's no way to delay, That trouble comin' every day",
  "My name is Mud, Not to be confused with Bill or Jack or Pete or Dennis, My name is Mud and it's always been",
  "Watch out where the huskies go, and don't you eat that yellow snow",
  "Fear leads to panic, panic leads to pain, Pain leads to anger, anger leads to hate, Hey, ey, ey, ey, Danny Nedelko"
];
